import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DistributorService } from '../../services/distributor.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';


@Component({
  selector: 'app-view-distributor',
  templateUrl: './view-distributor.component.html',
  styleUrls: ['./view-distributor.component.css'],
  providers:[DistributorService]
})
export class ViewDistributorComponent implements OnInit {
  id: number = undefined;
  private sub: any;
  distributor: any = {};

  constructor(private distributorService: DistributorService, private route: ActivatedRoute, private router: Router, public toastr: ToastsManager, vcr: ViewContainerRef) {
                this.toastr.setRootViewContainerRef(vcr);
               }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      if (params['id'] !== undefined){
        this.id = params['id'];
        this.getDistributor();
      }
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getDistributor(){
    this.distributorService.get(this.id).subscribe((distributor) => {
      this.distributor = distributor;
    });
  }

  saveDistributor(){
      if (this.distributor.id == undefined){
          this.distributorService.create(this.returnDistributorProperties(this.distributor))
          .subscribe((distributor) => {
            this.distributorService.get(distributor.id).subscribe((distributor) => {
              this.distributor = distributor;
            });
          });
      }else{
          this.distributorService.update(this.returnDistributorProperties(this.distributor))
          .subscribe((distributor) => {
            this.distributor = distributor;
          });
      }
  }

  

  returnDistributorProperties(distributor){
    var properties = {
      cif: distributor.cif,
      name: distributor.name,
      address: distributor.address,
      telephone: distributor.telephone
    }
    if (distributor.id){
      properties['id'] = distributor.id;
    }
    return properties;
  }

   
}



// WEBPACK FOOTER //
// ./src/app/distributors/components/view-distributor/view-distributor.component.ts